class Support {
    constructor(element) {
        this.el = element;
        if (!this.el) return;

        this.buttons = this.el.querySelectorAll(".support__amounts button");
        this.custom_amount = this.el.querySelector("[data-custom-donation-input]");
        this.init();
    }

    init() {
        // Toggle on active button
        this.buttons.forEach((button) => {
            button.addEventListener("click", (e) => {
                // Remove active class from currently active button
                let active = button.parentNode.querySelector(".active");
                if (active) {
                    active.classList.remove("active");
                }
                button.classList.add("active");

                // Clear custom amount
                if (this.custom_amount) {
                    this.custom_amount.value = "";
                }

                // Toggle membership panels if aria-controls exists
                const controls = button.getAttribute("aria-controls");
                if (controls) {
                    const panel = this.el.querySelector(`#${controls}`);
                    const allPanels = this.el.querySelectorAll("spektrix-memberships");

                    allPanels.forEach((p) => {
                        p.setAttribute("aria-hidden", "true");
                    });

                    if (panel) {
                        panel.setAttribute("aria-hidden", "false");
                    }
                }
            });
        });

        // Toggle off active button upon entering a custom amount
        if (this.custom_amount) {
            this.custom_amount.addEventListener("keyup", (input) => {
                let active = this.el.querySelector("[fund-id] .active");
                if (active) {
                    active.classList.remove("active");
                }
            });
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const support_blocks = document.querySelectorAll(".support.section");

    support_blocks.forEach((element) => {
        new Support(element);
    });
});

export default Support;
